import { css } from 'aphrodite';
import * as React from 'react';
import { IPlatformValidationError } from '../../../../models/utils/socialPostValidation';
import { THEME } from '../../../components-v2/Theme/theme';
import { DangerIcon } from '../../svgs/icons/DangerIcon';
import { styleSheet } from './styles';

interface IProps {
	errors: IPlatformValidationError[];
	/** Set while the panel sits inside the composer field, which draws the border around it. */
	inField?: boolean;
}

export const PlatformValidationErrors: React.FC<IProps> = ({ errors, inField }) => {
	if (!errors.length) {
		return null;
	}

	return (
		<div className={css(styleSheet.errorPanel, !inField && styleSheet.errorPanelStandalone)} role='alert'>
			{errors.map((error, index) => (
				<div className={css(styleSheet.errorRow)} key={`${error.platform}-${error.field}-${index}`}>
					<DangerIcon
						backgroundColor={THEME.colors.danger.main}
						borderColor={THEME.colors.danger.light}
						className={css(styleSheet.errorIcon)}
					/>
					<span>{error.message}</span>
				</div>
			))}
		</div>
	);
};
